import { CheckCircle2, Circle, Clock } from "lucide-react";
import { Chip } from "../ui-bits";
import { Card, PRIORITY_LABEL, fmtDate } from "./common";

export function ReadinessList({ detail, members, onComplete }) {
  const name = (id) => members.find(m => m.id === id)?.name;
  const req = detail.checks.filter(c => c.required);
  return (
    <Card title={`Informazioni per la produzione · ${detail.completion}%`} testId="sampling-readiness"
      action={detail.ready ? <Chip tone="green">Pronto per la produzione</Chip> : <Chip tone="gold">{detail.missing.length} da completare</Chip>}>
      <div className="h-1 mb-5" style={{ background: "var(--border)" }}><div className="h-1 bg-green-600 transition-all" style={{ width: `${detail.completion}%` }}/></div>
      <ul className="divide-y" style={{ borderColor: "var(--border)" }}>
        {req.map(c => {
          const t = detail.tasks[c.key];
          const open = t && t.status !== "done";
          return (
            <li key={c.key} className="py-3 flex flex-wrap items-center gap-3" data-testid={`check-${c.key}`}>
              {c.ok ? <CheckCircle2 size={16} className="text-green-600"/> : c.due ? <Circle size={16} className="text-orange-500"/> : <Clock size={16} className="opacity-40"/>}
              <div className="flex-1 min-w-[200px]">
                <div className={`text-sm ${c.ok ? "opacity-60" : "font-medium"}`}>{c.label}</div>
                <div className="text-xs opacity-60">{c.ok ? "Completo" : c.due ? c.hint : `Richiesto dalla fase ${c.stage_label}`}</div>
              </div>
              {open && (
                <span className="text-xs opacity-80" data-testid={`check-task-${c.key}`}>
                  Promemoria · {name(t.assignee_id) || "non assegnato"} · {fmtDate(t.start_date)} · {PRIORITY_LABEL[t.priority] || t.priority}
                </span>
              )}
              {!c.ok && <button onClick={() => onComplete(c)} className="text-xs uppercase tracking-widest underline-offset-4 hover:underline" data-testid={`check-complete-${c.key}`}>Completa</button>}
            </li>
          );
        })}
      </ul>
      <p className="text-xs opacity-60 mt-3">I promemoria compaiono anche in Attività: puoi assegnarli, cambiare data e priorità. Si chiudono da soli quando inserisci il dato.</p>
    </Card>
  );
}
